// extracted by mini-css-extract-plugin
export var actionIcon = "_se-0";